import { init, register } from 'svelte-i18n';

const defaultLocale = 'en';
const fallbackLocale = 'en';

// Register locales
register('en', () => import('../../locales/en.json'));
register('de', () => import('../../locales/de.json'));

/**
 * Detect browser language and return supported locale
 * Falls back to English if unsupported
 */
export function detectBrowserLocale(): string {
  if (typeof window === 'undefined') return defaultLocale;

  const browserLang = navigator.language.split('-')[0]; // e.g., 'en' from 'en-US'

  // Map browser language to supported locales
  const supportedLocales: Record<string, string> = {
    en: 'en',
    de: 'de',
  };

  return supportedLocales[browserLang] || defaultLocale;
}

/**
 * Initialize i18n with detected locale
 * @param initialLocale - Optional initial locale (e.g., from user settings)
 */
export async function initializeI18n(initialLocale?: string): Promise<void> {
  const locale = initialLocale || detectBrowserLocale();

  await init({
    fallbackLocale,
    initialLocale: locale,
    loadingDelay: 200,
  });
}

/**
 * Normalize a full locale code (e.g. 'de-DE') to a svelte-i18n locale ('de').
 * Falls back to 'en' if the language is not supported.
 */
export function normalizeLocale(locale: string): string {
  const lang = locale.split('-')[0];
  const supportedLocales: Record<string, string> = { en: 'en', de: 'de' };
  return supportedLocales[lang] || 'en';
}

/**
 * Get list of supported locales
 */
export function getSupportedLocales() {
  return [
    { code: 'en', label: 'English', nativeLabel: 'English' },
    { code: 'de', label: 'Deutsch', nativeLabel: 'Deutsch' },
  ];
}
